import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";

export const saveEMR = (obj, preAssessment) => {
  return apiClient.post(`/emr/save/${preAssessment}`, obj, {
    headers: authHeader(),
  });
};

export const updateEMR = (obj) => {
  return apiClient.put(`/emr/update`, obj, {
    headers: authHeader(),
  });
};

export const getPatientEmrPatch = (
  opdIpd,
  opdIpdId,
  doctorId,
  isPreAssessment,
  patientId,
) => {
  return apiClient.get(
    `/emr/getPatientEmrDetails/${opdIpd}/${opdIpdId}/${doctorId}/${isPreAssessment}/${patientId}`,
    {
      headers: authHeader(),
    },
  );
};

export const getPatientLastMedications = (patientId, doctorId) => {
  return apiClient.get(`/emr/getPatientLastMedications/${patientId}/${doctorId}`, {
    headers: authHeader(),
  });
};

export const startEMRConsultation = (visitId) => {
  return apiClient.get(`/emr/startEmr/${visitId}`, {
    headers: authHeader(),
  });
};
